import { DOCUMENT_MODE } from "../../../constants/document";
import DummyCommand from "../dummyCommand";
import AddDocQuoteTableCommand from "./addDocQuoteTableCommand";
import AddTemplateQuoteTableCommand from "./addTemplateQuoteTableCommand";

class AddQuoteTableFactory {
  static getCommand(mode, componentData) {
    if (mode === DOCUMENT_MODE.DOCUMENT) {
      return new AddDocQuoteTableCommand(componentData);
    }
    if (mode === DOCUMENT_MODE.TEMPLATE) {
      return new AddTemplateQuoteTableCommand(componentData);
    }
    return new DummyCommand();
  }
}

export default AddQuoteTableFactory;
